import { Component, OnInit } from '@angular/core';
import {PtyWsService} from "../../services/pty-ws.service";
import {DomSanitizer} from "@angular/platform-browser";

@Component({
  selector: 'app-welcome-video',
  templateUrl: './welcome-video.component.html',
  styleUrls: ['./welcome-video.component.scss'],
})
export class WelcomeVideoComponent implements OnInit {

  video: any = {};
  didFetch: boolean = false;

  constructor(
      private ws: PtyWsService,
      private domSanitizer: DomSanitizer,
  ) {

    this.loadVideo();

  }

  ngOnInit() {}

  loadVideo() {
    let self = this;
      self.ws.invokeURL('trainings', { page: '1' })
          .subscribe((result: any) => {
            if (result.error == 0 && result.trainings[0].url) {
              self.video = result.trainings[0];

              const videoId =  this.extractVideoId(self.video.url);

              if (videoId) {
                self.video.url = `https://www.youtube.com/embed/${videoId}?autoplay=1&showinfo=0&controls=0`;
              }


              self.video.isSanitized = false;
              let videoInfo = self.video;
              videoInfo.sanitizedUrl = self.domSanitizer.bypassSecurityTrustResourceUrl(videoInfo.url);
              self.video = { ...videoInfo, ...self.video };
              self.video.isSanitized = true;
              this.didFetch = true;
              console.log(this.video);
            }
          }, (err: any) => {
            this.didFetch = true;
            console.error('Error loading trainings', err);
          });
  }

  extractVideoId(video) {
    let videoId;
    let startOfUrl;
    let queryParams = /(\?\w*=(\w)*(\d)*)$/g;

    video.trim();

    if (video.includes('watch?v')) {
      startOfUrl = /^((https?:\/\/)?(www\.)?youtube\.com\/watch\?v=)/g;
    } else if (video.includes('youtu.be')) {
      startOfUrl = /^((https?:\/\/)?(www\.)?youtu\.be\/)/g;
    } else if (video.includes('embed')) {
      startOfUrl = /^((https?:\/\/)?(www\.)?youtube\.com\/embed\/)/g;
    } else {
      console.log('regex this edge case:', video);
      return '';
    }

    videoId = video.replace(startOfUrl, '');
    videoId = videoId.replace(queryParams, '');

    return videoId;
  }

}
